import React from 'react'
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { compose } from 'redux'
import injectTranslate from 'i18n/hoc/injectTranslate'
import { PRO_AUTH_LOGIN, proAuthLogin } from 'store/actions'
import { createValidator, required, email } from 'services/validation'
import { fromStatus } from 'store/selectors'

import LoginFormPro from './LoginFormPro'

const LoginFormProContainer = props => <LoginFormPro {...props} />

const onSubmit = (values, dispatch, props) =>
  dispatch(
    proAuthLogin.request({
      formName: 'SignInForm',
      email: values.email,
      password: values.password,
      grantType: 'password',
      redirectPathname: props.redirectPathname || null,
    }),
  )

const validate = createValidator({
  email: [required, email],
  password: [required],
})

export const config = {
  form: 'SignInForm',
  destroyOnUnmount: false,
  onSubmit,
  validate,
}

const mapStateToProps = state => ({
  isLoading: fromStatus.isLoading(state, PRO_AUTH_LOGIN.prefix),
})

export default compose(
  injectTranslate,
  connect(mapStateToProps),
  reduxForm(config),
)(LoginFormProContainer)
